{
	"type": "line",
	"minzoom": 8,
	"filter": ["has", "indicativespeedlimit"],
	"layout": {},
	"paint": {
		"line-color": [
			"match",
			["get", "indicativespeedlimit"],
			"10",
			"#f789d8",
			"20",
			"#6b6bd6",
			"30",
			"#6e0e21",
			"40",
			"#a7c636",
			"50",
			"#999999",
			"60",
			"#f51400",
			"70",
			"#ffde3e",
			"80",
			"#fc921f",
			"90",
			"#3caf99",
			"100",
			"#149ece",
			"110",
			"#b7814a",
			"#ddd"
		],
		"line-width": 5
	}
}
